/*
 * @Author: zhaosujuan zhaosujuan@freedodata.com
 * @Date: 2022-10-26 17:13:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-11-15 11:57:26
 * @FilePath: \lyws-official-websit\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 引用vuex，进行状态管理
 */
 import Vue from 'vue';
 import Vuex from 'vuex';
 import { mutChangeDefaultActivePath } from './mutation-types';
 import { getDeviceType, getClientWidth } from '@/utils/device.js';

 Vue.use(Vuex);
 const Client_Width = 'Client_Width';
 const GET_IS_MOBILE = 'GET_IS_MOBILE';
 const { isMobile } = getDeviceType();
 export default new Vuex.Store({
     modules: {
         
     },
     state: {
        defaultActivePath: '',
        isMobile,
        clientWidth: getClientWidth()
     },
     mutations: {
        async [Client_Width](state, clientWidth) {
            state.clientWidth = clientWidth;
        },
        async [GET_IS_MOBILE](state, val) {
            state.isMobile = val;
        },
        async [mutChangeDefaultActivePath](state, info) {
            state.defaultActivePath = info;
        },
     },
     actions: {},
     getters: {}
 });


// WEBPACK FOOTER //
// ./src/store/index.js